import Core from 'application/Shared/Helpers/Functions';
import axios from 'axios';
import { Component } from 'react';

class IntegrationEnabled extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: false
        };
    }

    async componentDidMount() {
        const { integrationKey } = this.props;
        let enabled = false;

        try {
            const response = await axios.get('/integrations/config');

            if (Core.isset(response, 'data', 'config', integrationKey)) {
                enabled = response.data.config[integrationKey].enabled;
            }

            this.setState({ enabled });
        } catch (e) {
            /* */
        }
    }

    render() {
        const { children } = this.props;
        const { enabled } = this.state;

        if (!enabled) {
            return null;
        }

        return children;
    }
}
export default IntegrationEnabled;
